<template>
  <div>
    <el-table :data="bugsData" size="mini" style="width: 100%">
      <el-table-column prop="状态" label="状态" width="100">
        <template slot-scope="scope">
          <select v-model="scope.row['状态']" @change="changeStatus(scope.row)">
            <option v-for="opt in options" :key="opt" :value="opt">{{opt}}</option>
          </select>
        </template>
      </el-table-column>
      <el-table-column prop="名称" label="名称" width="200"></el-table-column>
      <el-table-column prop="描述" label="描述"></el-table-column>
      <el-table-column label="截图" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="viewImg(scope.row['截图'])">查看</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="用户" label="用户" width="100"></el-table-column>
    </el-table>
    <el-dialog title="截图" fullscreen :close-on-click-modal="false" :visible.sync="dialogVisible">
      <img v-if="imgUrl" :src="imgUrl" style="width:100%">
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      bugsData: [],
      imgUrl: '',
      options: ['未处理', '已解决', '非bug', '无法重现', '待讨论', '暂缓解决'],
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData: async function() {
      const res = await app.service('misc').listBugs()
      console.log(res)
      if (res.status === 'success') {
        this.bugsData = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    viewImg: function(url) {
      this.dialogVisible = true
      this.imgUrl = url
    },
    changeStatus: async function(row) {
      const res = await app.service('misc').modifyBug({ _id: row._id, data: { 状态: row['状态'] } })
      if (res.status === 'success') {
        this.$message.success('操作成功')
      } else {
        this.$message.error(res.msg)
      }
    },
  },
}
</script>




